import { EnterExitDailyRecord } from '../EnterExitDailyRecord'
import { Common } from '@/core/Common';
import { DataType } from '../../DataType';
import { FView } from '@/core/FView';
import moment from 'moment';

export class EnterExitColoredRecord extends EnterExitDailyRecord {
    public weekAgoRecord:EnterExitDailyRecord | undefined;

    getColorClass(varName: string) {
        return this.getColorDiff(varName);
    }

    getColorDiff(varName: string) : string | null {
        return Common.GetColorClassByDiff((this as any)[varName] / (this.weekAgoRecord as any)[varName]);
    }

    public static getAllDates() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitDailyRecord>(DataType.EnterExitDaily);
        let shownDataSet = dataSet.filter(r => r.shown);
        return shownDataSet.flatMap(r => r.stat_date).filter((v, i, a) => a.indexOf(v) === i);
    }

    public static getAllPlaces() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitDailyRecord>(DataType.EnterExitDaily);
        let shownDataSet = dataSet.filter(r => r.shown);
        let places = shownDataSet.flatMap(r => r.address).filter((v, i, a) => a.indexOf(v) === i).sort();
        return places;
    }

    public static getColoredRecords() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitDailyRecord>(DataType.EnterExitDaily);
        let allDates = this.getAllDates();
        let allPlaces = this.getAllPlaces();
        let result:Record<string, Record<string, EnterExitColoredRecord>> = {};

        for (let date of allDates) {
            let weekAgoDate = moment(date).subtract(7, 'd').format('YYYY-MM-DD');
            result[date] = {}

            for (let place of allPlaces) {
                let record = this.findRecord(dataSet, date, place);
                let computedRecord: EnterExitColoredRecord;
                if (record != null) {
                    computedRecord = Object.assign<EnterExitColoredRecord, EnterExitDailyRecord>(new EnterExitColoredRecord(), record);
                    computedRecord.weekAgoRecord = this.findRecord(dataSet, weekAgoDate, place);
                } else {
                    computedRecord = new EnterExitColoredRecord();
                }
                result[date][place] = computedRecord;
            }
        }

       return result;
    }

    private static findRecord(dataSet:EnterExitDailyRecord[], date:string, place:string) {
        return dataSet.find(r => r.stat_date == date && r.address == place);
    }
}
